import React from 'react';
import {
  Label,
  Input,
} from '@americanexpress/dls-react';
import PropTypes from 'prop-types';

const InformationEditPage = (props) => {
  const { formData, setFormData } = props;

  return (
    <form className="margin-responsive">
      <div className="max-width-75">
        <Label className="pad-responsive-t">
          First Name <span className="dls-red">*</span>
        </Label>
        <Input
          id="firstName"
          value={formData.supplierFirstName ?? ''}
          onChange={(event) => setFormData({
            ...formData,
            supplierFirstName: event.target.value,
          })}
        />

        <Label className="pad-responsive-t">
          Last Name <span className="dls-red">*</span>
        </Label>
        <Input
          id="lastName"
          value={formData.supplierLastName ?? ''}
          onChange={(event) => setFormData({
            ...formData,
            supplierLastName: event.target.value,
          })}
        />

        <Label className="pad-responsive-t">
          Phone <span className="dls-red">*</span>
        </Label>
        <Input
          id="phone"
          value={formData.supplierPhoneNo ?? ''}
          onChange={(event) => setFormData({
            ...formData,
            supplierPhoneNo: event.target.value,
          })}
        />

        <Label className="pad-responsive-t">
          Email <span className="dls-red">*</span>
        </Label>
        <Input
          id="email"
          value={formData.supplierEmail ?? ''}
          onChange={(event) => setFormData({
            ...formData,
            supplierEmail: event.target.value,
          })}
        />
      </div>
    </form>
  );
};

InformationEditPage.propTypes = {
  formData: PropTypes.func,
  setFormData: PropTypes.func,
};

export default InformationEditPage;
